module.exports = __webpack_public_path__ + "static/media/4.96df6d79.jpg";